import React from 'react';
import styled from 'styled-components';
import SideBar from 'containers/sideBar/SideBar';
import TopBar from 'containers/topBar/TopBar';

const StyledHeaderAndMenu = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
  flex: 1;
`;

const StyledContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow-y: scroll;
  flex: 1;
`

const HeaderAndMenuLayout = ({ children }: any) => {
  const sidebarRef = React.useRef<HTMLDivElement | null>(null);

  return (
    <StyledHeaderAndMenu>
      <SideBar forwardedRef={sidebarRef}/>
      <StyledContentWrapper>
        <TopBar forwardedRef={sidebarRef}/>
        {children}
      </StyledContentWrapper>
    </StyledHeaderAndMenu>
  );
};

export default HeaderAndMenuLayout;